export default __webpack_public_path__ + "static/media/4Industry.701b1606.png";